window.addEventListener('load', function () {
  document.querySelectorAll('.carousel, .toplist--slider').forEach(function (elem) {
    elem.classList.remove('fadein');
  });

  document.querySelectorAll('.glider').forEach(function (elem) {
    new Glider(elem, {
      slidesToShow: 'auto',
      slidesToScroll: 'auto',
      itemWidth: 364,
      skipTrack: true,
      draggable: true,
      resizeLock: false,
      arrows: {
        prev: '.glider-prev',
        next: '.glider-next'
      }
    });
  });

  document.querySelectorAll('.jackpot-carousel, .slots-carousel, .jackpot-grid').forEach(function (elem) {
    new Glider(elem, {
      slidesToShow: 1.5,
      slidesToScroll: 1,
      itemWidth: 271,
      draggable: true,
      resizeLock: false,
      responsive: [{
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 2.5,
        }
      }]
    });
  });

  document.querySelectorAll('.other-slots').forEach(function (elem) {
    new Glider(elem, {
      slidesToShow: 'auto',
      slidesToScroll: 'auto',
      itemWidth: 208,
      exactWidth: true,
      skipTrack: true,
      draggable: true,
      resizeLock: false,
      dragVelocity: 1,
      duration: 1,
      arrows: {
        prev: '.glider-prev',
        next: '.glider-next'
      }
    });
  });
});